import React from 'react';

export const Expire = () => (
        <>
            <h2>Уже закончилась ⌛</h2>

            <div>Победителям напишем на электронную почту 📩</div>

            <h2>Всем спасибо за участие!</h2>
        </>
    )


